export default __webpack_public_path__ + "static/media/character_thumbailTemp.29f97fa1.png";